module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBold.e4dd295.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/OpenSans-SemiBold/OpenSans-SemiBold.eot
// module id = uLg4
// module chunks = 24